import styleInject from '../../node_modules/style-inject/dist/style-inject.es.js';

var css_248z = ".ltBlackSearch {\n  background-color: #33383e !important;\n  color: #888 !important;\n  border: none !important;\n}\n.ltBlackSearch > input {\n  color: #c4c4c4 !important;\n}\n.ltBlackSearch:focus-within {\n  box-shadow: inset 0 0 0 2px #3690f7 !important;\n}\n";
styleInject(css_248z);

export { css_248z as default };
